// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import Button from '@mui/material/Button'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'
import ToiletCheckQuestionTable from './ToiletCheckQuestionTable'
import ToiletCheckQuestionDialog from './ToiletCheckQuestionDialog'
import css from './toiletCheckQuestionPage.css'
import RestrictedView from '../../auth/RestrictedView'
type ToiletCheckQuestionPageProps = {
  data: Array<ToiletCheckQuestion>
  stationId?: string
}
type ToiletCheckQuestionPageState = {
  isDialogOpen: boolean
  data: ToiletCheckQuestion | null | undefined
}

class ToiletCheckQuestionPage extends React.Component<ToiletCheckQuestionPageProps, ToiletCheckQuestionPageState> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: ToiletCheckQuestion) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { data: toiletCheckQuestions, stationId } = this.props
    const { isDialogOpen, data } = this.state
    return (
      <div className={css.component}>
        <ToiletCheckQuestionTable data={toiletCheckQuestions} stationId={stationId} onEdit={this.onEdit} />
        <div className={css.bottom}>
          <RestrictedView requiredPermission='manage_ownStation'>
            <Button onClick={this.openDialog} variant='contained' color='primary'>
              {i18n.t('buttons.create')}
            </Button>
          </RestrictedView>
        </div>
        <ToiletCheckQuestionDialog data={data} stationId={stationId} isOpen={isDialogOpen} onClose={this.closeDialog} />
      </div>
    )
  }
}

export default ToiletCheckQuestionPage
